import * as types from '../constants/ActionTypes';

export function closeGlobalModal() {
	return { type: types.CLOSE_GLOBAL_MODAL };
}



// WEBPACK FOOTER //
// ./src/assets/js/actions/global-modal.js